import BaseService from './BaseService';
import { camelizeKeys } from 'humps';

class ReportsService extends BaseService {

  static report(path, data) {
    return super.post('reports', `reports/${path}`, camelizeKeys(data))
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

}

export default ReportsService;